import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-right\"><path d=\"M671.589 511.711l-39.518-39.518-230.692-230.692-0.021 0.021a28.115 28.115 0 0 0-0.809-0.851c-10.935-10.935-28.663-10.935-39.598 0-10.935 10.935-10.935 28.663 0 39.598 0.278 0.278 0.564 0.545 0.851 0.809l-0.021 0.021L592.472 511.79l-231.94 231.94c-10.935 10.935-10.935 28.663 0 39.598s28.663 10.935 39.598 0L671.668 511.79l-0.079-0.079z\" p-id=\"2285\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/right.svg
// module id = 9iyg
// module chunks = 27